import React, { useEffect, useRef, useState } from "react";
import "./addmember.css";
import Steps1 from "./Steps1";
import Steps2 from "./Steps2";
import Steps3 from "./Steps3";
import Steps4 from "./Steps4";
import Steps5 from "./Steps5";
import Steps6 from "./Steps6";
import axios from "axios";
import { API } from "../../config";

const AddMembers = () => {
  const [count, setCount] = useState(0);
  const [formData, setFormData] = useState({});
  const [initialData, setInitialData] = useState("");
  const [completedSteps, setCompletedSteps] = useState([]);
  const stepRefs = useRef([]);

  // API call to fetch data
  const fetchData = async () => {
    axios.get(`${API}/?action=init&format=new`)
    .then((res)=>{
      setInitialData(res?.data?.data) 
    })
    .catch((err)=>console.log(err))
  };
  useEffect(() => {
    fetchData();
  }, []);

  // Scroll to the active step when `count` changes
  // useEffect(() => {
  //   if (stepRefs.current[count]) {
  //     stepRefs.current[count].scrollIntoView({
  //       behavior: "smooth",
  //       inline: "center",
  //       block: "nearest",
  //     });
  //   }
  //   window.scrollTo({ top: 0, behavior: "smooth" });
  // }, [count]);

  window.scrollTo(0, 0);

  const handelDetails = (data) => {
    setFormData({ ...formData, ...data });
  };
  const handleStep = (step) => {
    if (completedSteps.includes(step) || step <= count) {
      setCount(step);
    }
  };

  const completeCurrentStep = (currentStep) => {
    if (!completedSteps.includes(currentStep)) {
      setCompletedSteps([...completedSteps, currentStep]);
    }
  };

  console.log(formData);

  return (
    <div>
      <br />
      <div>
        <div
          className="  col-sm-10   col-11 d-flex align-items-start m-auto justify-content-between position-relative"
          style={{ color: "#034DA2", columnGap: "50px", overflowX: "auto" }}
        >
          <div
            className="line "
            style={{
              position: "absolute",
              top: "25px",
              left: "25px",
              width: "96%",
              height: "2px",
              background: "#AEC4E0",
            }}
          >
            <div
              style={{
                width: `${(Math.max(...completedSteps, count) / 5) * 100}%`,
                height: "2px",
                background: "#034DA2",
              }}
            ></div>
          </div>

          {/* Step 1 */}
          <div
            ref={(el) => (stepRefs.current[0] = el)}
            className="d-flex align-items-center justify-content-center z-1"
            onClick={() => handleStep(0)} // Update active step
            style={{ cursor: "pointer" }}
          >
            <div>
              <div
                className={`progressStatus ${
                  completedSteps.includes(0) || count >= 0 ? "active" : ""
                }`}
              >
                01
              </div>
              <p className="d-flex justify-content-center mb-0">
                {/* <b className="responsive-hide">Personal</b> */}
              </p>
              <b className="responsive-hide wrap mt-2">Basic Details</b>
            </div>
          </div>

          {/* Step 2 */}
          <div
            ref={(el) => (stepRefs.current[1] = el)}
            className="d-flex align-items-center justify-content-center z-1"
            onClick={() => handleStep(1)} // Update active step
            style={{ cursor: "pointer" }}
          >
            <div>
              <div
                className={`progressStatus ${
                  completedSteps.includes(1) || count >= 1 ? "active" : ""
                }`}
              >
                02
              </div>
              <p className="d-flex justify-content-center mb-0">
                {/* <b className="responsive-hide">Address</b> */}
              </p>
              <b className="responsive-hide wrap mt-2">Address Info</b>
            </div>
          </div>

          {/* Step 3 */}
          <div
            ref={(el) => (stepRefs.current[2] = el)}
            className="d-flex align-items-center justify-content-center z-1"
            onClick={() => handleStep(2)} // Update active step
            style={{ cursor: "pointer" }}
          >
            <div>
              <div
                className={`progressStatus ${
                  completedSteps.includes(2) || count >= 2 ? "active" : ""
                }`}
              >
                03
              </div>
              <p className="d-flex justify-content-center mb-0">
                {/* <b className="responsive-hide">Contact</b> */}
              </p>
              <b className="responsive-hide wrap mt-2">Contact Info</b>
            </div>
          </div>

          {/* Step 4 */}
          <div
            ref={(el) => (stepRefs.current[3] = el)}
            className="d-flex align-items-start text-center justify-content-center z-1"
            onClick={() => handleStep(3)} // Update active step
            style={{ cursor: "pointer" }}
          >
            <div>
              <div
                className={`progressStatus ${
                  completedSteps.includes(3) || count >= 3 ? "active" : ""
                }`}
              >
                04
              </div>
              <p className="d-flex justify-content-center mb-0">
                {/* <b className="responsive-hide">Education/Occupation</b> */}
              </p>
              <b className="responsive-hide mt-2">Education/Occupation Info</b>
            </div>
          </div>

          {/* Step 5 */}
          <div
            ref={(el) => (stepRefs.current[4] = el)}
            className="d-flex align-items-center justify-content-center z-1"
            onClick={() => handleStep(4)} // Update active step
            style={{ cursor: "pointer" }}
          >
            <div>
              <div
                className={`progressStatus ${
                  completedSteps.includes(4) || count >= 4 ? "active" : ""
                }`}
              >
                05
              </div>
              <p className="d-flex justify-content-center mb-0">
                {/* <b className="responsive-hide wrap">Mandal Info</b> */}
              </p>
              <b className="responsive-hide wrap mt-2">Mandal Info</b>
            </div>
          </div>

          {/* Step 6 */}
          <div
            ref={(el) => (stepRefs.current[5] = el)}
            className="d-flex align-items-center justify-content-center z-1"
            onClick={() => handleStep(5)} // Update active step
            style={{ cursor: "pointer" }}
          >
            <div>
              <div className={`progressStatus ${count >= 5 ? "active" : ""}`}>
                06
              </div>
              <p className="d-flex justify-content-center mb-0">
                {/* <b className="responsive-hide wrap">Seva Skill</b> */}
              </p>
              <b className="responsive-hide mt-2 wrap">Seva Skill</b>
            </div>
          </div>
        </div>
      </div>

      <div className="col-11 m-auto">
        {count === 0 && (
          <Steps1
            completeCurrentStep={completeCurrentStep}
            count={count}
            setCount={setCount}
            detailsSet={handelDetails}
            details={formData}
            initialData={initialData}
          />
        )}
        {count === 1 && (
          <Steps2
            completeCurrentStep={completeCurrentStep}
            count={count}
            setCount={setCount}
            detailsSet={handelDetails}
            details={formData}
            initialData={initialData}
          />
        )}
        {count === 2 && (
          <Steps3
            completeCurrentStep={completeCurrentStep}
            count={count}
            setCount={setCount}
            detailsSet={handelDetails}
            details={formData}
            initialData={initialData}
          />
        )}
        {count === 3 && (
          <Steps4
            completeCurrentStep={completeCurrentStep}
            count={count}
            setCount={setCount}
            detailsSet={handelDetails}
            details={formData}
            initialData={initialData}
          />
        )}
        {count === 4 && (
          <Steps5
            completeCurrentStep={completeCurrentStep}
            count={count}
            setCount={setCount}
            detailsSet={handelDetails}
            details={formData}
            initialData={initialData}
          />
        )}
        {count === 5 && (
          <Steps6
            count={count}
            setCount={setCount}
            detailsSet={handelDetails}
            details={formData}
            initialData={initialData}
          />
        )}
      </div>

      <br />
    </div>
  );
};

export default AddMembers;

{
  /* Sidebar */
}
{
  /* <div
        className="sidebar bg-primary text-white"
        style={{ width: "250px", padding: "20px" }}
      >
        <h4 className="mb-4">Anoopam Mission</h4>
        <ul className="nav flex-column">
          <li className="nav-item mb-2">
            <a href="#basic-details" className="nav-link text-white">
              Basic Details
            </a>
          </li>
          <li className="nav-item mb-2">
            <a href="#address-info" className="nav-link text-white">
              Address Info
            </a>
          </li>
          <li className="nav-item mb-2">
            <a href="#contact-info" className="nav-link text-white">
              Contact Info
            </a>
          </li>
          <li className="nav-item mb-2">
            <a href="#education" className="nav-link text-white">
              Education/Occupation
            </a>
          </li>
          <li className="nav-item mb-2">
            <a href="#mandal-info" className="nav-link text-white">
              Mandal Info
            </a>
          </li>
          <li className="nav-item">
            <a href="#seva-skill" className="nav-link text-white">
              Seva Skill
            </a>
          </li>
        </ul>
      </div> */
}

// <div className="d-flex p-2 ">
//   {/* Sidebar */}
//   <div
//     className="sidebar mt-5 rounded-4 "
//     style={{
//       width: "250px",
//       padding: "20px",
//       flexShrink: 0,
//     }}
//   >
//     <ul className="nav flex-column">
//       <li className="nav-item mb-2">
//         <a href="#basic-details" className="nav-link side-text">
//           Basic Details
//         </a>
//       </li>
//       <li className="nav-item mb-2">
//         <a href="#address-info" className="nav-link side-text">
//           Address Info
//         </a>
//       </li>
//       <li className="nav-item mb-2">
//         <a href="#contact-info" className="nav-link side-text">
//           Contact Info
//         </a>
//       </li>
//       <li className="nav-item mb-2">
//         <a href="#education" className="nav-link side-text">
//           Education/Occupation
//         </a>
//       </li>
//       <li className="nav-item mb-2">
//         <a href="#mandal-info" className="nav-link side-text">
//           Mandal Info
//         </a>
//       </li>
//       <li className="nav-item">
//         <a href="#seva-skill" className="nav-link text">
//           Seva Skill
//         </a>
//       </li>
//     </ul>
//   </div>

//   {/* Content Section */}
//   <div className=" content flex-grow-1  mt-4">
//     <div
//       className="dashboard hide col-sm-10 col-11 d-flex align-items-start m-auto justify-content-between position-relative"
//       style={{ color: "#034DA2", columnGap: "50px", overflowX: "auto" }}
//     >
//       <div
//         className="line"
//         style={{
//           position: "absolute",
//           top: "25px",
//           left: "25px",
//           width: "96%",
//           height: "2px",
//           background: "#AEC4E0",
//         }}
//       >
//         <div
//           style={{
//             width: `${(count / 5) * 100}%`,
//             height: "2px",
//             background: "#034DA2",
//           }}
//         ></div>
//       </div>

//       {/* Step 1 */}
//       <div
//         ref={(el) => (stepRefs.current[0] = el)}
//         className="d-flex align-items-center justify-content-center z-1"
//         // onClick={() => setCount(0)}
//         // style={{ cursor: "pointer" }}
//       >
//         <div>
//           <div className={`progressStatus ${count >= 0 ? "active" : ""}`}>
//             01
//           </div>
//           <p className="d-flex justify-content-center mb-0">
//             {/* <b className="responsive-hide">Personal</b> */}
//           </p>
//           <b className="responsive-hide wrap mt-2">Basic Details</b>
//         </div>
//       </div>

//       {/* Step 2 */}
//       <div
//         ref={(el) => (stepRefs.current[1] = el)}
//         className="d-flex align-items-center justify-content-center z-1"
//         //  onClick={() => setCount(1)}
//         // style={{ cursor: "pointer" }}
//       >
//         <div>
//           <div className={`progressStatus ${count >= 1 ? "active" : ""}`}>
//             02
//           </div>
//           <p className="d-flex justify-content-center mb-0">
//             {/* <b className="responsive-hide">Address</b> */}
//           </p>
//           <b className="responsive-hide wrap mt-2">Address Info</b>
//         </div>
//       </div>

//       {/* Step 3 */}
//       <div
//         ref={(el) => (stepRefs.current[2] = el)}
//         className="d-flex align-items-center justify-content-center z-1"
//         // onClick={() => setCount(2)}
//         // style={{ cursor: "pointer" }}
//       >
//         <div>
//           <div className={`progressStatus ${count >= 2 ? "active" : ""}`}>
//             03
//           </div>
//           <p className="d-flex justify-content-center mb-0">
//             {/* <b className="responsive-hide">Contact</b> */}
//           </p>
//           <b className="responsive-hide wrap mt-2">Contact Info</b>
//         </div>
//       </div>

//       {/* Step 4 */}
//       <div
//         ref={(el) => (stepRefs.current[3] = el)}
//         className="d-flex align-items-start text-center justify-content-center z-1"
//         // onClick={() => setCount(3)}
//         // style={{ cursor: "pointer" }}
//       >
//         <div>
//           <div className={`progressStatus ${count >= 3 ? "active" : ""}`}>
//             04
//           </div>
//           <p className="d-flex justify-content-center mb-0">
//             {/* <b className="responsive-hide">Education/Occupation</b> */}
//           </p>
//           <b className="responsive-hide mt-2">Education/Occupation Info</b>
//         </div>
//       </div>

//       {/* Step 5 */}
//       <div
//         ref={(el) => (stepRefs.current[4] = el)}
//         className="d-flex align-items-center justify-content-center z-1"
//         // onClick={() => setCount(4)}
//         // style={{ cursor: "pointer" }}
//       >
//         <div>
//           <div className={`progressStatus ${count >= 4 ? "active" : ""}`}>
//             05
//           </div>
//           <p className="d-flex justify-content-center mb-0">
//             {/* <b className="responsive-hide wrap">Mandal Info</b> */}
//           </p>
//           <b className="responsive-hide wrap mt-2">Mandal Info</b>
//         </div>
//       </div>

//       {/* Step 6 */}
//       <div
//         ref={(el) => (stepRefs.current[5] = el)}
//         className="d-flex align-items-center justify-content-center z-1"
//         // onClick={() => setCount(5)}
//         // style={{ cursor: "pointer" }}
//       >
//         <div>
//           <div className={`progressStatus ${count >= 5 ? "active" : ""}`}>
//             06
//           </div>
//           <p className="d-flex justify-content-center mb-0">
//             {/* <b className="responsive-hide wrap">Seva Skill</b> */}
//           </p>
//           <b className="responsive-hide mt-2 wrap">Seva Skill</b>
//         </div>
//       </div>
//     </div>

//     {/* Render steps based on count */}
//     <div className="col-11 m-auto">
//       {count === 0 && (
//         <Steps1
//           count={count}
//           setCount={setCount}
//           detailsSet={handelDetails}
//           details={formData}
//         />
//       )}
//       {count === 1 && (
//         <Steps2
//           count={count}
//           setCount={setCount}
//           detailsSet={handelDetails}
//           details={formData}
//         />
//       )}
//       {count === 2 && (
//         <Steps3
//           count={count}
//           setCount={setCount}
//           detailsSet={handelDetails}
//           details={formData}
//         />
//       )}
//       {count === 3 && (
//         <Steps4
//           count={count}
//           setCount={setCount}
//           detailsSet={handelDetails}
//           details={formData}
//         />
//       )}
//       {count === 4 && (
//         <Steps5
//           count={count}
//           setCount={setCount}
//           detailsSet={handelDetails}
//           details={formData}
//         />
//       )}
//       {count === 5 && (
//         <Steps6
//           count={count}
//           setCount={setCount}
//           detailsSet={handelDetails}
//           details={formData}
//         />
//       )}
//     </div>
//   </div>
// </div>
